import * as React from 'react';

import {ChartTooltip} from 'shells/charts/chart-tooltip';

type PayloadValues = {
    bucket: string;
    count: number;
};
type Props = {
    active: boolean;
    payload: {
        payload: PayloadValues[];
    };
    domains: {
        name: string;
        fill: string;
    }[];
};

export const TrafficLineChartTooltip = (props: Props) => {
    // @ts-expect-error
    const payload = props.active ? props.payload[0].payload : undefined;

    if (payload) {
        const {monthName, ...payloadDomains} = payload;

        return (
            <ChartTooltip
                header={{text: monthName}}
                rows={props.domains.map((domain) => ({
                    label: domain.name,
                    value: `${payloadDomains[domain.name].toLocaleString()} visits`,
                    dotColor: domain.fill,
                }))}
            />
        );
    }

    return <></>;
};
